// Client skins switched on with the `skin` URL parameter, e.g. index.html?id=…&skin=czantoria.
// Each skin's styles live in src/assets/scss/skins/ under html[data-skin='<name>'].
const skins = {
  czantoria: {
    fonts: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap'
  }
}

export default {
  apply(name) {
    const skin = skins[name]
    if (!skin) return null

    document.documentElement.setAttribute('data-skin', name)
    if (skin.fonts) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = skin.fonts
      document.head.appendChild(link)
    }
    return name
  }
}
